import React, { useState, useEffect } from 'react';
import {useRedux} from "../../../hooks";
import {
    Col, Label, Row, Spinner,
} from 'reactstrap';
import 'emojionearea/dist/emojionearea';
import 'emojionearea/dist/emojionearea.css';
import '../../../i18/config';
import {useTranslation} from "react-i18next";

import {
    Formik,
    Form,
    Field
} from 'formik';
import ButtonSpinner from "../../../components/ButtonSpinner";
import InputFile from "../../../components/InputFile";
import {MainFileType} from "../../../redux/Main/File/types";
import {CommentType} from "../../../redux/Main/Comment/types";
import {CommentValidatorSchema} from "./validator";
import InputMentionEmojiArea from "../../../components/InputMentionEmojiArea";

interface InputProps {
    item: CommentType;
    isSending: boolean;
    onSend: (data:any)=>any,
    onClose: ()=>void
}

const CommentForm = ({item, isSending, onSend, onClose}:InputProps) => {

    const { t } = useTranslation(['common']);
    const { dispatch, useAppSelector } = useRedux();

    const uuid = item.uuid || null;

    const {
        mainContacts
    } = useAppSelector(state => ({
        mainContacts: state.MainUser.contacts
    }));

    const [formValues, setFormValues] = useState<CommentType>(item);
    const [isShowAttachForm, setShowAttachForm] = useState<boolean>(false);

    useEffect(() => {
        setFormValues(item);

        if (item?.uuid !== null && (item?.media || []).length>0){
            setShowAttachForm(true);
        } else {
            setShowAttachForm(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, dispatch, item]);

    const handleShowAttachForm = () => {
        setShowAttachForm(true);
    }


    const onDataSubmit = (formData:CommentType) => {
        let attachmentFiles=[];

        let params: CommentType = {
            uuid: formData.uuid && formData.uuid,
            enabled: formData.enabled && formData.enabled,
            text: formData.text && formData.text,
            media: formData.media && formData.media,
            owner: item.owner && item.owner,
            actions: item.actions && item.actions
        };

        if (item?.task !== undefined && item?.task?.uuid !== null){
            params = {
                ...params,
                task:{
                    uuid:item.task.uuid
                }
            }
        }
        if (item?.saleOrder !== undefined && item?.saleOrder?.uuid !== null){
            params = {
                ...params,
                saleOrder:{
                    uuid:item.saleOrder.uuid
                }
            }
        }

        (formData.media|| []).map((fileItem:MainFileType)=>{
            if (fileItem.uuid === undefined){
                attachmentFiles.push(fileItem);
            }
            return fileItem;
        });

        if (attachmentFiles.length>0){
            params['attachmentFiles']=attachmentFiles;
        }

        dispatch(onSend(params));
    };

    return (
        <>
                <Formik
                    enableReinitialize={true}
                    initialValues={formValues}
                    validationSchema={CommentValidatorSchema}
                    onSubmit={(values, actions) => {
                        onDataSubmit(values);
                        actions.setSubmitting(false);
                    }}
                >
                    {({ errors, touched, setFieldValue, getFieldProps, isSubmitting, isValidating }) => (
                    <Form noValidate={true} className="customValidation d-flex flex-grow-1 flex-column">

                            <Row>
                                <div className={ "mb-3"+ (touched.text ? " was-validated" : '')}>
                                    <Label className="form-label" htmlFor="form-text-input">{t('comment:comment')}</Label>
                                    <div className="textAreaEmojiBlock">
                                        <Field
                                            id="form-text-input"
                                            name="text"
                                            component={InputMentionEmojiArea}
                                            value = {getFieldProps('text').value}
                                            onChange={(text:string) => {
                                                setFieldValue('text', text);
                                            }}
                                            required={true}
                                            contacts={mainContacts || []}
                                            placeholder={t('support:textHere')}
                                        />
                                        {errors.text && touched.text ? (
                                            <div className="invalid-feedback">
                                                {t('validator:'+errors.text)}
                                            </div>
                                        ) :  touched.text && !errors.text ?
                                            <div className="valid-feedback">
                                                {t('common:looksGood')}
                                            </div>
                                            : ''
                                        }
                                    </div>
                                </div>
                            </Row>
                                    {isShowAttachForm &&
                                    <Row>
                                        <div className="mb-3">
                                            <Field
                                                id={"form-attachmentFiles-input"}
                                                name={'media'}
                                                placeholder={t('support:filePlaceholder')}
                                                isMultiple={true}
                                                component={InputFile}
                                                value={getFieldProps('media').value}
                                                onChange={(value: MainFileType[]) => {
                                                    setFieldValue('media', value);
                                                }}
                                                required={false}
                                            />
                                        </div>
                                    </Row>
                                    }

                        <Row>
                            <Col xs={12} className="text-end">
                                {!isShowAttachForm &&
                                <button type="button"
                                        onClick={handleShowAttachForm}
                                        className="btn btn-ghost-secondary btn-icon waves-effect me-2"><i className="ri-attachment-line fs-16"/></button>
                                }
                                <button type="button"
                                        onClick={onClose}
                                        className="btn btn-light btn-label waves-effect waves-light me-2">
                                    <i
                                        className="ri-close-line label-icon align-middle fs-16 me-2"/>
                                        {t('common:cancel')}
                                </button>
                                <button type="submit"
                                        disabled={isSending}
                                        className="btn btn-success btn-label waves-effect waves-light">
                                    {isSending ?
                                        <ButtonSpinner className={'ms-0'}/>
                                        :
                                        <i
                                            className="ri-mail-send-line label-icon align-middle fs-16 me-2"/>
                                    }
                                    {t('support:sendMessage')}
                                </button>
                            </Col>
                        </Row>
                    </Form>
                        )}
                </Formik>
        </>
    );
}

export default CommentForm;